import React from 'react'
import { ItemAnswer } from '../'
import arrayifyWithKey from '../../../../helpers/arrayifyWithKey';
import alphaNum from '../../../../helpers/alphaNum';
import alphaNumF from '../../../../helpers/alphaNumF';
import totalArray from '../../../../helpers/totalArray';
import values from 'mout/object/values'
import ItemNotAnswered from '../ItemNotAnswered.js'
import uuid from 'uuid/v1'

export default function ItemAnswers({
  activeItem,
  isGroup,
  answersByItem,
  selectedAnswer,
  selectAnswer,
  completed,
  scoring,
  fontValue
}) {

  if (activeItem) {

    const answersArray = arrayifyWithKey(activeItem.answers)
    let itemAnswers = []
    let totalPercent = 0;
    answersArray.forEach((answer, n) => {
      let percent = null
      if (isGroup && answersByItem) {
        const numerator = answersByItem[answer.key] ? answersByItem[answer.key] : '0'
        percent = Math.round(numerator / totalArray(values(answersByItem)) * 100);
        if (scoring !== undefined && activeItem.itemId && scoring[activeItem.itemId]) {
          let curectAnswerData = scoring[activeItem.itemId];
          percent = Math.round((numerator / curectAnswerData.possible) * 100);
        }

        if (scoring !== undefined && answer.correct === true && activeItem.itemId && scoring[activeItem.itemId]) {
          let curectAnswerData = scoring[activeItem.itemId];
          percent = Math.round((curectAnswerData.raw / curectAnswerData.possible) * 100);
        }

        if (scoring !== undefined && activeItem.itemId && scoring[activeItem.itemId]) {

          if (percent !== null) {
            totalPercent = Math.round(totalPercent + percent);
          }
        }
      }
      let active = false
      if (selectedAnswer === answer.key) {
        active = true
      }
      let choice = ''
      if (activeItem.startingLetter.toLowerCase() === 'f') {
        choice = alphaNumF[n.toString()]
      } else {
        choice = alphaNum[n.toString()]
      }
      let IsstudentNotAnswered = false;

      itemAnswers.push({
        active,
        choice,
        percent,
        answer,
        IsstudentNotAnswered
      })
    })
    let studentNotAnswered = 0;
    if (isGroup && answersByItem) {
      if (totalPercent != 0) {
        studentNotAnswered = Math.round(100 - totalPercent);
      }

    }
    if (studentNotAnswered > 1) {
      let answer = studentNotAnswered + "% of students left this question unanswered.";
      let IsstudentNotAnswered = true;
      let active = false;
      let percent = 0;
      let choice = false;
      itemAnswers.push({
        active,
        choice,
        percent,
        answer,
        IsstudentNotAnswered
      })
    }

    if (studentNotAnswered === 1) {
      let answer = "Percentages may not add up to 100% due to rounding.";
      let IsstudentNotAnswered = true;
      let active = false;
      let percent = 0;
      let choice = false;
      itemAnswers.push({
        active,
        choice,
        percent,
        answer,
        IsstudentNotAnswered
      })
    }
    console.log('itemAnswers', itemAnswers);
    return (
      <div>
        {itemAnswers.map(({ active, choice, answer, percent, IsstudentNotAnswered }, n) => {
          return (
            IsstudentNotAnswered === true ?
              (<ItemNotAnswered
                key={'itemAnswer' + uuid()}
                answer={answer}
                fontValue={fontValue}
              />)
              :
              (<ItemAnswer
                key={'itemAnswer' + uuid()}
                active={active}
                choice={choice}
                answer={answer}
                selectAnswer={selectAnswer}
                completed={completed}
                percent={percent}
                fontValue={fontValue}
              />)
          )
        }
        )}
      </div>
    )
  } else return null
}













// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessTestComponents/ItemAnswers.js